/**
 * Free landing page photos (Unsplash CDN — no API key, publicly accessible).
 */
function unsplash(photoId, width = 900) {
  return `https://images.unsplash.com/${photoId}?w=${width}&auto=format&fit=crop&q=80`;
}

export const LANDING_IMAGES = {
  hero: unsplash('photo-1523240795612-9a054b0db644', 1200),
  avatar1: unsplash('photo-1494790108755-2616b9e8b1b8', 200),
  avatar2: unsplash('photo-1507003211169-0a1dd7228f2d', 200),
  avatar3: unsplash('photo-1438761681033-6461ffad8d80', 200),
  about: unsplash('photo-1523050854058-8df90110c9f1', 900),
  approachCurriculum: unsplash('photo-1456513080510-7bf3a84b82f8', 900),
  approachSmartLearning: unsplash('photo-1516321318453-407ee5169477', 900),
  approachExpertGuidance: unsplash('photo-1522202176988-66273c2fd55f', 900),
  collage1: unsplash('photo-1427504494785-3a9ca7044f45', 900),
  collage2: unsplash('photo-1488521787991-ed7bbaae773c', 900),
  collage3: unsplash('photo-1501504905252-473c47e087f8', 900),
  fallback: unsplash('photo-1523050854058-8df90110c9f1', 900),
};

/** Generic placeholder when an image URL fails to load. */
export const PLACEHOLDER_IMAGE = LANDING_IMAGES.fallback;

export const COLLAGE_IMAGES = [
  LANDING_IMAGES.collage1,
  LANDING_IMAGES.collage2,
  LANDING_IMAGES.collage3,
];

export const HERO_STUDENT_IMG = LANDING_IMAGES.hero;
export const ABOUT_IMG = LANDING_IMAGES.about;

export const APPROACH_CARD_IMAGES = {
  curriculum: LANDING_IMAGES.approachCurriculum,
  smartLearning: LANDING_IMAGES.approachSmartLearning,
  expertGuidance: LANDING_IMAGES.approachExpertGuidance,
};
